import { useId, useRef, useState } from "react";
import axios from "../../api/axiosInstance";

export async function saveUnitVisibility(url, payload, config) {
  try {
    const { data } = await axios.put(url, payload, config);
    return data;
  } catch (failure) {
    if (failure.response?.data?.code === "UNIT_IN_USE") return { is_hidden: false, is_in_use: true };
    throw failure;
  }
}

export default function UnitVisibilityCheckbox({ unit, name, words, disabled, onSave }) {
  const [saving, setSaving] = useState(false);
  const [failed, setFailed] = useState(false);
  const pending = useRef(false);
  const hintId = useId();
  const hidden = unit.is_hidden === true;
  const inUse = !hidden && unit.is_in_use === true;
  const locked = disabled || unit.can_change_visibility === false || inUse;

  const change = async (event) => {
    if (locked || pending.current) return;
    pending.current = true;
    setSaving(true);
    setFailed(false);
    try {
      await onSave(event.target.checked);
    } catch {
      setFailed(true);
    } finally {
      pending.current = false;
      setSaving(false);
    }
  };

  return <>
    <input type="checkbox" checked={hidden} disabled={saving || locked} onChange={change}
      aria-label={`${words.hide}: ${name}`} aria-describedby={inUse ? hintId : undefined} />
    {inUse && <small id={hintId} role="status"> {words.inUse}</small>}
    {failed && <small role="alert"> {words.visibilityError}</small>}
  </>;
}
